import { RestService, Rest } from '@abp/ng.core';
import { Injectable } from '@angular/core';
import type { IActionResult } from '../microsoft/asp-net-core/mvc/models';

@Injectable({
  providedIn: 'root',
})
export class ExternalLoginService {
  apiName = 'Default';
  

  googleByReturnUrl = (returnUrl: string = "http://localhost:4200", config?: Partial<Rest.Config>) =>
    this.restService.request<any, IActionResult>({
      method: 'GET',
      url: '/external/google',
      params: { returnUrl },
    },
    { apiName: this.apiName,...config });
  

  googleCallbackByReturnUrl = (returnUrl: string = "http://localhost:4200", config?: Partial<Rest.Config>) =>
    this.restService.request<any, IActionResult>({
      method: 'GET',
      url: '/external/signin-google',
      params: { returnUrl },
    },
    { apiName: this.apiName,...config });
  

  registerGoogleByReturnUrlAndSommelierSlug = (returnUrl: string = "http://localhost:4200", sommelierSlug?: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, IActionResult>({
      method: 'GET',
      url: '/external/register-google',
      params: { returnUrl, sommelierSlug },
    },
    { apiName: this.apiName,...config });
  

  registerGoogleCallbackByReturnUrlAndSommelierSlug = (returnUrl: string = "http://localhost:4200", sommelierSlug?: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, IActionResult>({
      method: 'GET',
      url: '/external/signin-register-google',
      params: { returnUrl, sommelierSlug },
    },
    { apiName: this.apiName,...config });

  constructor(private restService: RestService) {}
}
